<template>
  <div class="row">
    <div :class="leftColClasses">
      <toggle-switch
        :id="id"
        :name="name"
        :disabled="loading || disabled"
        class="mb-1"
        @change="handleValueChange"
        v-model="marketingFlag"
      />
    </div>
    <div :class="rightColClasses">
      <div class="invalid-feedback" v-show="error">{{ i18n.errorMessage }}</div>
      <div class="txt_privacy">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

export default {
  props: {
    initMarketingFlagUrl: {
      type: String,
    },
    initEmailId: {
      type: String,
    },
    marketingFlagOn: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'adv_accept'
    },
    name: {
      type: String,
      default: 'adv_accept'
    },
    leftColClasses: {
      type: String,
      default: 'col-md-1'
    },
    rightColClasses: {
      type: String,
      default: 'col-md-11'
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ToggleSwitch: () => import(/* webpackChunkName: "chunk-toggle-switch" */ './input/toggle-switch.vue'),
  },
  data() {
    return {
      error: null,
      loading: false,
      i18n: {
        errorMessage: gettext('Something went wrong!'),
      },
    };
  },
  methods: {
    async updateMarketingFlag(event) {
      try {
        this.loading = true;
        this.error = null;

        if (!this.initEmailId || !this.initMarketingFlagUrl) {
          return;
        }

        const isChecked = event?.target?.checked || false;

        const payload = {
          email_id: this.initEmailId,
          type: isChecked ? 'subscribe' : 'unsubscribe',
        };

        const headers = {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
        };

        await this.$http.post(this.initMarketingFlagUrl, payload, {headers});

      } catch (error) {
        console.error('Error:', error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    handleValueChange(event) {
      this.updateMarketingFlag(event);
    },
  },
  computed: {
    marketingFlag: {
      get() {
        return this.marketingFlagOn;
      },
      set(value) {
        this.$emit('update:marketingFlagOn', value);
      }
    }
  }
};
</script>

